import { useMemo } from "react";
import ReportSettingsSection from "./ReportSettingsSection";
import TeamLeaderReportPreviewDrawer from "./TeamLeaderReportPreviewDrawer";
import {
  useGetTeamLeaderSettingsQuery,
  useGetTeamLeaderPreviewQuery,
  useUpdateTeamLeaderSettingsMutation,
  useGetSeniorManagerPreviewQuery,
} from "./weeklyCheckInReportSettingsApi";

const TeamLeaderReportSettingsSection = () => {
  const { data: settings, isLoading, isError } =
    useGetTeamLeaderSettingsQuery();
  const { data: preview, isLoading: isPreviewLoading } =
    useGetTeamLeaderPreviewQuery();
  const [updateSettings, { isLoading: isSaving }] =
    useUpdateTeamLeaderSettingsMutation();
  const { data: seniorManagerPreview } = useGetSeniorManagerPreviewQuery();

  const adjustedPreview = useMemo(() => {
    if (!preview?.summary || !seniorManagerPreview?.recipients) return preview;

    const seniorManagerIds = new Set(
      seniorManagerPreview.recipients
        .filter(
          (r) =>
            r.status === "qualified_by_rules" ||
            r.status === "included_override"
        )
        .map((r) => r.userAccountId)
    );

    // Count how many "receiving" team leader recipients also receive the senior manager report,
    // split by status so we subtract from the correct summary fields
    let qualifiedOverlap = 0;
    let includedOverlap = 0;
    for (const r of preview.recipients) {
      if (!seniorManagerIds.has(r.userAccountId)) continue;
      if (r.status === "qualified_by_rules") qualifiedOverlap++;
      else if (r.status === "included_override") includedOverlap++;
    }

    return {
      ...preview,
      summary: {
        ...preview.summary,
        qualifiedByRules: preview.summary.qualifiedByRules - qualifiedOverlap,
        includedOverride: preview.summary.includedOverride - includedOverlap,
      },
    };
  }, [preview, seniorManagerPreview]);

  return (
    <ReportSettingsSection
      settings={settings}
      isLoading={isLoading}
      isError={isError}
      preview={adjustedPreview}
      isPreviewLoading={isPreviewLoading}
      isSaving={isSaving}
      updateSettings={updateSettings}
      reportName="Team Leader Check-in Report"
      thresholdCopyText="of their team members are invited to check-ins"
      PreviewDrawer={TeamLeaderReportPreviewDrawer}
    />
  );
};

export default TeamLeaderReportSettingsSection;
